import axios from "./../../http/axios";
import {
  GET_ALL_PROJECTS,
  GET_DEALROOMS,
  token,
  GET_DEALROOM_FIN_STR,
  GET_DEALROOM_PROJECTS,
  EDIT_DEALROOM_PROJECT,
  EDIT_DEALROOM_FIN_STR,
  EDIT_DEALROOM,
  SET_SCENARIO_PROJECTS,
  SET_SCENARIO_FIN_STR,
  DELETE_PPROJECT_FROM_DEALROOM,
  DELETE_FIN_STR_FROM_DEALROOM,
  GET_DEALROOM_PROJECTS_SCENARIOS,
  GET_SCENARIO_PROJECTS, GET_DEALROOM_FIN_STR_SCENARIOS, GET_SCENARIO_FIN_STRS
} from "./types";

export const getAllProjects = () => dispatch => {
  const url = `user-schemas/UserProject/`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_ALL_PROJECTS,
        payload: res.data.results
      });
    });
};

export const getDealrooms = (page) => dispatch => {
  const url = `dealrooms/dealroom/?page=${page}`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_DEALROOMS,
        payload: {items:res.data.results,count:res.data.count}
      });
    });
};

export const getDealroomProjects = (id) => dispatch => {
  const url = `dealrooms/dealroom-projects/${id}`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_DEALROOM_PROJECTS,
        payload: res.data.projects
      });
    });
};

export const getDealroomFinStr = (id) => dispatch => {
  const url = `dealrooms/dealroom-financial-structures/${id}`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_DEALROOM_FIN_STR,
        payload: res.data.financial_structures
      });
    });
};

export const setDealroom = (data) => () => {
  const url = `dealrooms/dealroom/`;
  return axios
    .post(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return res.data.dealroom;
    });
};

export const editDealroomProject = (data, id) => dispatch => {

  const url = `/dealrooms/update-project/${id}/`;
  return axios
    .patch(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      if (res.data.detail !== "up to date") {
        return dispatch({
          type: EDIT_DEALROOM_PROJECT,
          payload: {projectId: id, project: res.data.detail}
        });
      }
    });
};

export const editDealroomFinStr = (data, id) => dispatch => {

  const url = `/dealrooms/update-financial-structure/${id}/`;
  return axios
    .patch(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      if (res.data.detail !== "up to date") {
        return dispatch({
          type: EDIT_DEALROOM_FIN_STR,
          payload: {finStrId: id, financialStructure: res.data.detail}
        });
      }
    });
};

export const editDealroom = (data, id) => dispatch => {

  const url = `/dealrooms/dealroom/${id}/`;
  return axios
    .put(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: EDIT_DEALROOM,
        payload: res
      });
    });
};

export const creatingScenarioProjcetsSet = (choosenProjectsArray, newProjectScenarioCreating) => dispatch => {
  return dispatch({
    type: SET_SCENARIO_PROJECTS,
    payload: {choosenProjectsArray, newProjectScenarioCreating}
  });
};

export const creatingScenarioFinStrSet = (choosenFinStr, newFinStrScenarioCreating) => dispatch => {
  return dispatch({
    type: SET_SCENARIO_FIN_STR,
    payload: {choosenFinStr, newFinStrScenarioCreating}
  });
};

export const createProjectScenario = (data) => () => {
  const url = `/dealrooms/scenario-projects/`;
  return axios
    .post(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
};

export const createFinancialStructureScenario = (data) => () => {
  const url = `/dealrooms/scenario-financial-structure/`;
  return axios
    .post(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
};

export const deleteProjectFromDealroom = (id) => dispatch => {
  return dispatch({type: DELETE_PPROJECT_FROM_DEALROOM, payload: id})
};

export const deleteFinStrFromDealroom = (id) => dispatch => {
  return dispatch({type: DELETE_FIN_STR_FROM_DEALROOM, payload: id})
};

export const getDealroomProjectsScenarios = (id) => dispatch => {
  const url = `dealrooms/dealroom-scenario-projects/${id}`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_DEALROOM_PROJECTS_SCENARIOS,
        payload: res.data.scenarios
      });
    });
};

export const getScenarioProjects = (id) => dispatch => {
  const url = `dealrooms/scenario-projects/${id}`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_SCENARIO_PROJECTS,
        payload: res.data
      });
    });
};

export const getScenarioFinStrs = (id) => dispatch => {
  const url = `dealrooms/scenario-financial-structure/${id}`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_SCENARIO_FIN_STRS,
        payload: res.data
      });
    });
};

export const getDealroomFinStrScenarios = (id) => dispatch => {
  const url = `/dealrooms/dealroom-scenario-financial-structures/${id}`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_DEALROOM_FIN_STR_SCENARIOS,
        payload: res.data.scenarios
      });
    });
};

export const editDealroomProjectScenario = (data, id) => () => {
  const url = `/dealrooms/scenario-projects/${id}/`;
  return axios
    .put(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
};

export const editDealroomFinStrScenario = (data, id) => () => {
  const url = `/dealrooms/scenario-financial-structure/${id}/`;
  return axios
    .put(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
};


// WEBPACK FOOTER //
// ./src/store/actions/dealroom.js